module.exports = __webpack_public_path__ + "static/media/pladins.2df386bc.jpg";